import React, { Component } from "react";
import { Progress, Spin, Button } from "antd";
import { WhiteSpace } from "peak-design";
import Cookies from "universal-cookie";
import axios from "axios";
import ResizeAware from "react-resize-aware";
import styles from "./styles/search.module.scss";

//components
import { PageTitle } from "../../components/common";
import { PatientInfoFormCarousel } from "../../components/forms";

//images
import Logo from "../../assets/favicon-logo.jpg";

const API_URL = process.env.REACT_APP_API_URL;

class Search extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      fetchingValues: !this.props.isNew ? true : false,
      percent: 1,
      currentStep: 1,
      finished: false
    };
  }
  componentDidMount() {
    if (!this.props.isNew) {
      const cookies = new Cookies();
      const clientId = cookies.get("fasttrek-client");
      axios
        .get(`${API_URL}/client/${clientId}`)
        .then(res => {
          this.setState({ fetchingValues: false, existingValues: res.data });
        })
        .catch(err => {
          cookies.remove("fasttrek-client");
          this.props.history.push("/");
        });
    }
  }
  handleResize = ({ width, height }) => {
    window.parent.postMessage(height, "*");
  };
  handleSubmit = (e, form) => {
    e.preventDefault();
    this.setState({ loading: true, percent: 100, finished: true });
    form.validateFields((err, values) => {
      if (!err) {
        const cookies = new Cookies();
        const clientValues = values;
        clientValues.clinicalTrialsStudyStatus = [];
        const sendToClient = false;
        const clientId = cookies.get("fasttrek-client");
        axios
          .post(`${API_URL}/generate_report`, {
            clientValues,
            sendToClient,
            clientId
          })
          .then(res => {
            this.setState({ loading: false });
            this.props.history.push("/results", {
              results: res.data,
              values: clientValues
            });
          })
          .catch(err => {
            this.setState({ loading: false });
            console.log(err);
          });
      }
    });
  };

  onSlideChange = current => {
    this.setState({
      percent: (current / 7) * 100,
      currentStep: current + 1
    });
  };
  render() {
    const { loading, fetchingValues, existingValues } = this.state;
    const { isNew } = this.props;
    return (
      <ResizeAware onResize={this.handleResize} onlyEvent>
        <div className={styles.container} style={{ minHeight: 700 }}>
          <div className={styles.containerCentered}>
            <div className={styles.searchContainer}>
              <PageTitle title="FastTrek TrialTracker" />
              <WhiteSpace height={50} />
              <div className={styles.progressContainer}>
                <Progress
                  type="circle"
                  percent={this.state.percent}
                  status={this.state.finished ? "success" : ""}
                  format={() => (
                    <img src={Logo} className={styles.logo} alt="logo" />
                  )}
                />
              </div>
              <WhiteSpace height={50} />
              <div className={styles.formContainer}>
                <PatientInfoFormCarousel
                  handleSubmit={(e, form) => this.handleSubmit(e, form)}
                  loading={loading}
                  isNew={isNew}
                  fetchingValues={fetchingValues}
                  existingValues={existingValues}
                  onSlideChange={current => this.onSlideChange(current)}
                />
              </div>
            </div>
          </div>
          {this.state.loading ? (
            <div className={styles.loadingContainer}>
              <Spin size="large" tip="Generating reports..." />
            </div>
          ) : null}
        </div>
      </ResizeAware>
    );
  }
}

export { Search };



// WEBPACK FOOTER //
// ./src/containers/pages/Search.js